import React from "react";
import { Modal } from "react-bootstrap";
import Zoom from "react-medium-image-zoom";

export default function ArticleListReference({
  t,
  ShowModal,
  setShowModal,
  selectAricle,
  list,
  reference,
}: any) {
  const itemSelect = async (item: any) => {
    await selectAricle(item);
    setShowModal(false);
  };
  return (
    <div>
      <Modal
        show={ShowModal}
        onHide={() => setShowModal(false)}
        className="modal-3"
        dialogClassName="modal-40w"
        backdropClassName="modal-backdrop-2"
      >
        <Modal.Header>
          <Modal.Title className="c-primary">
            {t("Article de reference")} {reference}
            {}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="list">
            <div className="row layout-spacing">
              <div className="table-responsive">
                <table className="table">
                  <thead>
                    <th colSpan={2}>{t("Article")}</th>
                    <th>{t("Prix Vente")}</th>
                  </thead>

                  <tbody>
                    {list &&
                      list.length > 0 &&
                      list.map((item: any, index: number) => (
                        <tr key={index}>
                          <td>
                            <Zoom>
                              <img
                                alt=""
                                src={
                                  item.article.image && item.article.image[0]
                                    ? process.env.REACT_APP_API_PUBLIC_URL +
                                      "article/" +
                                      item.article.image[0]
                                    : "/assets/assets/img/no-image.jpg"
                                }
                                width="50"
                              />
                            </Zoom>
                          </td>
                          <td onClick={() => itemSelect(item)}>
                            <p className="lien-bleu-souligne ">
                              {item.article?.titre?.fr}
                            </p>
                            <p>{item.article?.code_article}</p>
                          </td>
                          <td
                            style={{
                              borderRight: "1px solid #eff1f1",
                            }}
                          >
                            {item.article?.prix_vente_ttc?.toFixed(3)}
                          </td>
                        </tr>
                      ))}
                    <tr></tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
